module.exports = __webpack_public_path__ + "img/db_01.32313b6c.png";